<template>
  <div v-if="branch">
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"branch.general.name" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">{{branch.branch}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"branch.general.description" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="branch.description" type="text" class="input oc-input" />
          </p>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button class="button is-success" @click="save()">{{"branch.general.save" | translate}}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import branchService from "../../../../services/branch.service"

  export default {
    name: 'branch-general',
    data() {
      return {
        branch: null
      }
    },
    computed: {
      branchName() {
        return this.$route.params.branch;
      }
    },
    async mounted() {
      await this.loadBranch();
    },
    methods: {
      async loadBranch() {
        this.branch = await branchService.get(this.branchName);
      },
      async save() {
        this.branch = await branchService.update(this.branch);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/branches/branch/general.vue